import React, {useContext, useEffect, useRef, useState} from "react";
import {Cancel, Save} from "@mui/icons-material";
import {AppbarContentContext} from "../../../../commons/routing/appbar/AppbarContentProvider";
import useNewScoredVideo from "./useNewScoredVideo";
import AppbarActionButton from "../../../../commons/elements/buttons/AppbarActionButton";
import GeneralEditScoredSceneForm from "../utils/GeneralEditScoredSceneForm";
import {useParams} from "react-router-dom";
import useLoadScoredScene from "../utils/useLoadScoredScene";
import LoadingProgressIndication from "../../../../commons/elements/progress/loading/LoadingProgressIndication";
import {useIntl} from "react-intl";

const NewScoredSceneSection = () => {

    // Get keys from parameter
    const {videoKey} = useParams()

    // The freshly loaded data based on the keys from the URL parameter
    const {selectedVideo, loading} = useLoadScoredScene(videoKey, null)

    // Hook to update the appbar
    const {setCurrentAppbarContent} = useContext(AppbarContentContext)

    // Hook providing the save user functionality
    const {save, cancel, saveInProgress} = useNewScoredVideo(selectedVideo)

    // Reference, which holds will hold the user data according to the current form data (from the general user component)
    const editedScoredScene = useRef()

    // Determines if the save button should be enabled.
    const [saveButtonEnabled, setSaveButtonEnabled] = useState(false)

    // Internationalization for simple strings
    const intl = useIntl();

    // Setting the appbar content
    useEffect(() => {
        setCurrentAppbarContent({
            header: intl.formatMessage({
                id: 'app.scoredScene.new.appbar.header',
                defaultMessage: 'Define Scene & Scores'
            }),
            description: intl.formatMessage({
                id: 'app.scoredScene.new.appbar.description',
                defaultMessage: 'Define scores for the selected video...'
            }),
            actions: <>
                <AppbarActionButton
                    label={intl.formatMessage({
                        id: 'app.scoredScene.new.appbar.actions.save',
                        defaultMessage: 'Create'
                    })}
                    onClick={() => save(editedScoredScene.current)}
                    disabled={!saveButtonEnabled}
                    icon={<Save/>}/>
                <AppbarActionButton
                    label={intl.formatMessage({
                        id: 'app.scoredScene.new.appbar.actions.cancel',
                        defaultMessage: 'Cancel'
                    })}
                    onClick={() => cancel()}
                    icon={<Cancel/>}/>
            </>,
            progress: saveInProgress
        })
    }, [saveButtonEnabled, selectedVideo, saveInProgress])

    if (saveInProgress) {
        return <LoadingProgressIndication
            text={intl.formatMessage({
                id: 'app.scoredScene.new.save.loading',
                defaultMessage: 'Creating video scene'
            })}/>
    }

    if (loading) {
        return <LoadingProgressIndication
            text={intl.formatMessage({
                id: 'app.scoredScene.new.video.loading',
                defaultMessage: 'Loading associated video'
            })}/>
    } else {
        return (
            <GeneralEditScoredSceneForm selectedVideo={selectedVideo}
                                        editedScoredSceneRef={editedScoredScene}
                                        setSaveButtonEnabled={setSaveButtonEnabled}/>
        );
    }
}
export default NewScoredSceneSection